import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import { Card } from "reactstrap";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
} from "../../../components/Component";
import { Steps, Step } from "react-step-builder";
import Header from "./Header";
// import PurchaseOrder_GeneralDetails from "./PurchaseOrder_GeneralDetails";
// import PurchaseOrder_Materails from "./PurchaseOrder_Materails";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
// import PurchaseOrder_Preview from "./PurchaseOrder_Preview";
import { Link } from "react-router-dom";
// import PurchaseOrderOthers from "./PurchaseOrderOthers";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import axios from "axios";
import { Flex, Spin } from "antd";
import GeneralDetails from "./GeneralDetails";
import Materails from "./Materails";
import Questioner from "./Questioner";
import Others from "./Others";
import Preview from "./Preview";
import tenderApis from "../../../api/tender/tenderApis";
import sitebreakdownMasterApis from "../../../api/master/sitebreakdownMaster";
import { nanoid } from "@reduxjs/toolkit";

dayjs.extend(isSameOrAfter);

const config = {
  before: Header as React.ComponentType<{}> as () => React.ReactElement,
};

const NewTenderMain: FC = () => {
  const [sm, setSm] = useState(false);
  const defaultSections: any[] = [
    {
      id: "general",
      name: "General",
      isCustom: false,
      sectionWeightage: "20",
      questions: [
        {
          id: "q1",
          questioner: "Does Your Company Follow Sustainability Principles?",
          questionType: "Yes/No",
          choiceOptions: ["Yes", "No"],
          questionWeightage: "34",
          description: "",
        },
        {
          id: "q2",
          questioner:
            "What differentiates your product or service from competitors?",
          questionType: "Long Text",
          questionWeightage: "33",
          description: "",
        },
        {
          id: "q3",
          questioner: "What is the age of your company?",
          questionType: "Single Choice",
          choiceOptions: ["<3 Years", ">3-5 Years", ">5-10 Years", ">10 Years"],
          questionWeightage: "33",
          description: "",
        },
      ],
    },
    {
      id: "technical",
      name: "Technical",
      sectionWeightage: "20",
      questions: [
        {
          id: "q1",
          questioner: "Do you have an in-house technical support team?",
          questionType: "Yes/No",
          description: "",
          choiceOptions: ["Yes", "No"],
          questionWeightage: "34",
        },
        {
          id: "q2",
          questioner: "Average technician dispatch time (in hours)?",
          questionType: "Short Text",
          description: "",
          questionWeightage: "33",
        },
        {
          id: "q3",
          questioner: "Provide detailed escalation matrix for support.",
          questionType: "Long Text",
          description: "",
          questionWeightage: "33",
        },
      ],
    },
    {
      id: "legal",
      name: "Legal",
      sectionWeightage: "20",
      questions: [
        {
          id: "q1",
          questioner: "Are you blacklisted by any Malaysian government entity?",
          questionType: "Yes/No",
          description: "",
          choiceOptions: ["Yes", "No"],
          questionWeightage: "34",
        },
        {
          id: "q2",
          questioner: "Choose the licenses your company currently holds.",
          questionType: "Multiple Choice",
          choiceOptions: ["MOF", "CIDB", "PETRONAS", "KKM", "HRDF"],
          description: "",
          questionWeightage: "33",
        },
        {
          id: "q3",
          questioner: "Have you ever breached a commercial contract?",
          questionType: "Yes/No",
          description: "",
          choiceOptions: ["Yes", "No"],
          questionWeightage: "33",
        },
      ],
    },
    {
      id: "commercial",
      name: "Commercial",
      sectionWeightage: "20",
      questions: [
        {
          id: "q1",
          questioner: "Are the unit prices negotiable?",
          questionType: "Yes/No",
          description: "",
          choiceOptions: ["Yes", "No"],
          questionWeightage: "34",
        },
        {
          id: "q2",
          questioner: "What is your payment term preference?",
          questionType: "Single Choice",
          description: "",
          choiceOptions: ["15 Days", "30 Days", "45 Days", "60 Days"],
          questionWeightage: "33",
        },
        {
          id: "q3",
          questioner: "Which product certifications do you hold?",
          questionType: "Multiple Choice",
          choiceOptions: [
            "ISO 9001",
            "CE Certified",
            "Energy Star",
            "TUV",
            "RoHS",
          ],
          description: "",
          questionWeightage: "33",
        },
      ],
    },
    {
      id: "documents",
      name: "Documents",
      sectionWeightage: "20",
      questions: [
        {
          id: "q1",
          questioner: "Upload your company profile.",
          questionType: "File Upload",
          description: "",
          questionWeightage: "50",
        },
        {
          id: "q2",
          questioner: "Upload MOF certification (if applicable).",
          questionType: "File Upload",
          description: "",
          questionWeightage: "50",
        },
      ],
    },
  ];
  const [mobileView, setMobileView] = useState(false);
  const formMethods = useForm({
    mode: "onChange",
    defaultValues: {
      tenderFor: "Material",
      questionerSections: defaultSections,
    },
  });
  const { watch, register, reset, setValue } = formMethods;

  const location = useLocation();
  const convertionData = location.state?.data;
  const draftId = location.state?.draftId;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!draftId) return;
    const loadDraft = async () => {
      try {
        setLoading(true);
        const apiResponse: any = await tenderApis.getTenderById(draftId);
        const data = apiResponse?.data;
        if (!data) {
          setLoading(false);
          return;
        }

        const tenderForForm =
          data.tenderFor === "Service" || data.tenderFor === "Work"
            ? "Service / Works"
            : "Material";

        // Resolve tower/flat labels from site structure since the tender API
        // typically returns only IDs (siteStructureUnitId / siteStructureSubUnitId)
        const towerLabelMap: Record<string, string> = {};
        const flatLabelMap: Record<string, string> = {};
        const tenderSiteId = data.siteId;
        if (tenderSiteId) {
          try {
            const towerRes: any = await sitebreakdownMasterApis.fetchUnitsBySiteId({
              siteId: tenderSiteId,
            });
            if (towerRes?.status && Array.isArray(towerRes.data)) {
              towerRes.data.forEach((u: any) => {
                if (u.id != null) towerLabelMap[String(u.id)] = u.unitName || "";
              });
            }
          } catch (e) {
            console.error("Failed to load tower options for draft:", e);
          }

          const lines: any[] =
            data.tenderFor === "Material" ? data.materials || [] : data.tasks || [];
          const uniqueTowerIds = Array.from(
            new Set(
              lines
                .map((m: any) => m.siteStructureUnitId)
                .filter((id: any) => id != null)
            )
          );
          await Promise.all(
            uniqueTowerIds.map(async (uid: any) => {
              try {
                const subRes: any =
                  await sitebreakdownMasterApis.fetchSubUnitsByUnitId({
                    siteId: tenderSiteId,
                    unitId: uid,
                  });
                if (subRes?.status && Array.isArray(subRes.data)) {
                  subRes.data.forEach((su: any) => {
                    if (su.id != null) {
                      flatLabelMap[String(su.id)] = su.subUnitName || su.unitName || "";
                    }
                  });
                }
              } catch (e) {
                console.error("Failed to load sub-units for draft:", e);
              }
            })
          );
        }

        const items =
          data.tenderFor === "Material"
            ? (data.materials || []).map((m: any) => {
                const categoryId =
                  m.materialCategoryId ??
                  m.materialCategory ??
                  m.categoryId ??
                  null;
                return {
                  id: m.tenderMaterialId ? String(m.tenderMaterialId) : nanoid(),
                  tenderMaterialId: m.tenderMaterialId,
                  materialName: m.materialId != null ? String(m.materialId) : "",
                  materialId: m.materialId,
                  materialLabel: m.materialName || "",
                  materialCategory: categoryId != null ? String(categoryId) : "",
                  materialCategoryId: categoryId,
                  materialCategoryName:
                    m.materialCategoryName || m.categoryName || "",
                  quantity: m.quantity,
                  uomId: m.uomId != null ? String(m.uomId) : "",
                  uomLabel: m.uomName || "",
                  description: m.description || "",
                  deliveryAddressId: m.deliveryAddressId,
                  needByDate: m.needByDate ? dayjs(m.needByDate) : null,
                  materialUsage: m.usage || "",
                  installationRequired: !!m.isInstallationRequired,
                  towerBlockVillaId: m.siteStructureUnitId,
                  towerBlockVillaLabel:
                    m.siteStructureUnitName ||
                    (m.siteStructureUnitId != null
                      ? towerLabelMap[String(m.siteStructureUnitId)] || ""
                      : ""),
                  floorNo: m.floorNo,
                  floorLabel: m.floorNo ? String(m.floorNo) : "",
                  flatId: m.siteStructureSubUnitId,
                  flatLabel:
                    m.siteStructureSubUnitName ||
                    (m.siteStructureSubUnitId != null
                      ? flatLabelMap[String(m.siteStructureSubUnitId)] || ""
                      : ""),
                  locationId: m.locationId,
                };
              })
            : (data.tasks || []).map((t: any) => ({
                id: t.tenderTaskId ? String(t.tenderTaskId) : nanoid(),
                tenderTaskId: t.tenderTaskId,
                workType: t.workType || "Open",
                workCategoryId: t.workCategoryId,
                workCategoryLabel: t.workCategoryName || "",
                workSubCategoryId: t.workSubCategoryId,
                taskTitle: t.taskTitle || "",
                description: t.description || "",
                quantity: t.quantity,
                uomId: t.uomId != null ? String(t.uomId) : "",
                uomLabel: t.uomName || "",
                taskUsage: t.usage || "",
                installationRequired: !!t.isInstallationRequired,
                towerBlockVillaId: t.siteStructureUnitId,
                towerBlockVillaLabel:
                  t.siteStructureUnitName ||
                  (t.siteStructureUnitId != null
                    ? towerLabelMap[String(t.siteStructureUnitId)] || ""
                    : ""),
                floorNo: t.floorNo,
                floorLabel: t.floorNo ? String(t.floorNo) : "",
                flatId: t.siteStructureSubUnitId,
                flatLabel:
                  t.siteStructureSubUnitName ||
                  (t.siteStructureSubUnitId != null
                    ? flatLabelMap[String(t.siteStructureSubUnitId)] || ""
                    : ""),
                locationId: t.locationId,
              }));

        const questionerSections = (data.questionnaireSections || []).map(
          (s: any) => ({
            id: s.tenderSectionId ? String(s.tenderSectionId) : nanoid(),
            tenderSectionId: s.tenderSectionId,
            name: s.sectionName,
            sectionWeightage:
              s.weightage != null ? String(s.weightage) : "",
            isCustom: !["General", "Technical", "Commercial"].includes(
              s.sectionName
            ),
            evaluators: (s.evaluators || []).map(
              (e: any) => e.userId
            ),
            evaluatorDetails: (s.evaluators || []).map((e: any) => ({
              userId: e.userId,
              userName: e.userName || String(e.userId),
            })),
            approvals: s.approvals || [],
            questions: (s.questions || []).map((q: any) => ({
              id: q.tenderQuestionId ? String(q.tenderQuestionId) : nanoid(),
              tenderQuestionId: q.tenderQuestionId,
              questioner: q.question || "",
              questionType: q.type || "Short Text",
              choiceOptions: q.options || [],
              questionWeightage:
                q.weightage != null ? String(q.weightage) : "",
              description: q.description || "",
            })),
          })
        );

        const allDocs = data.documents || [];
        const instructionsDoc = allDocs.find(
          (d: any) => d.moduleFileType === "Instructions"
        );
        const termsDoc = allDocs.find(
          (d: any) => d.moduleFileType === "TermsAndConditions"
        );
        const regularAttachments = allDocs
          .filter(
            (d: any) =>
              d.moduleFileType !== "Instructions" &&
              d.moduleFileType !== "TermsAndConditions"
          )
          .map((d: any) => ({
            uid: String(d.docId),
            name: d.fileName || `document-${d.docId}`,
            status: "done",
            url: d.filePath,
            docId: d.docId,
          }));

        let instructionsHtml = "";
        let termsHtml = "";
        try {
          if (instructionsDoc?.filePath) {
            const res = await fetch(instructionsDoc.filePath);
            instructionsHtml = await res.text();
          }
        } catch (e) {
          console.error("Failed to load instructions:", e);
        }
        try {
          if (termsDoc?.filePath) {
            const res = await fetch(termsDoc.filePath);
            termsHtml = await res.text();
          }
        } catch (e) {
          console.error("Failed to load terms:", e);
        }

        const formValues: any = {
          tenderNumber: data.tenderNumber || "",
          tenderTitle: data.tenderTitle || "",
          tenderType: data.tenderType || "Open",
          description: data.description || "",
          tenderFor: tenderForForm,
          siteId: data.siteId != null ? String(data.siteId) : "",
          projectId: data.siteId != null ? String(data.siteId) : "",
          lastSubmissionDate: data.lastSubmissionDate
            ? dayjs(data.lastSubmissionDate)
            : null,
          lastDateForExpressingInterest: data.lastDateForExpressingInterest
            ? dayjs(data.lastDateForExpressingInterest)
            : null,
          sealedBidSubmissionDate: data.sealedBidSubmissionDate
            ? dayjs(data.sealedBidSubmissionDate)
            : null,
          evaluationStartDate: data.evaluationStartDate
            ? dayjs(data.evaluationStartDate)
            : null,
          sealedBidPostalAddress: data.sealedBidPostalAddress || "",
          deliveryLineLevel: String(!!data.isLineLevelDelivery),
          approvalToPublish: String(!!data.approvalRequiredToPublish),
          questionerForEligibility: String(!!data.questionerForEligibility),
          approvalForEvaluation: String(!!data.approvalRequiredForEvaluation),
          documnetsRequired: String(
            !!data.documentsFromSuppliersOrContractors
          ),
          items,
          questionerSections:
            questionerSections.length > 0
              ? questionerSections
              : defaultSections,
          instructions: instructionsHtml,
          termsAndConditions: termsHtml,
          attachments: regularAttachments,
          supplierIds: (data.suppliers || [])
            .map((s: any) => s.supplierId ?? s.supplierID)
            .filter((id: any) => id != null)
            .map((id: any) => String(id)),
          contractorIds: (data.contractors || [])
            .map((c: any) => c.contractorId ?? c.contractorID)
            .filter((id: any) => id != null)
            .map((id: any) => String(id)),
          _editMode: true,
          _draftTenderId: draftId,
          _originalSupplierMap: (data.suppliers || []).reduce(
            (acc: Record<string, number>, s: any) => {
              const sid = s.supplierId ?? s.supplierID;
              const tsid = s.tenderSupplierId ?? s.tenderSupplierID;
              if (sid != null && tsid != null) {
                acc[String(sid)] = Number(tsid);
              }
              return acc;
            },
            {} as Record<string, number>
          ),
          _originalContractorMap: (data.contractors || []).reduce(
            (acc: Record<string, number>, c: any) => {
              const cid = c.contractorId ?? c.contractorID;
              const tcid = c.tenderContractorId ?? c.tenderContractorID;
              if (cid != null && tcid != null) {
                acc[String(cid)] = Number(tcid);
              }
              return acc;
            },
            {} as Record<string, number>
          ),
          _originalMaterialIds: (data.materials || [])
            .map((m: any) => m.tenderMaterialId)
            .filter(Boolean),
          _originalTaskIds: (data.tasks || [])
            .map((t: any) => t.tenderTaskId)
            .filter(Boolean),
          _originalSectionIds: (data.questionnaireSections || [])
            .map((s: any) => s.tenderSectionId)
            .filter(Boolean),
          _originalQuestionIdsBySection: (
            data.questionnaireSections || []
          ).reduce((acc: any, s: any) => {
            if (s.tenderSectionId) {
              acc[s.tenderSectionId] = (s.questions || [])
                .map((q: any) => q.tenderQuestionId)
                .filter(Boolean);
            }
            return acc;
          }, {} as Record<string, number[]>),
          _originalEvaluatorIdsBySection: (
            data.questionnaireSections || []
          ).reduce((acc: any, s: any) => {
            if (s.tenderSectionId) {
              acc[s.tenderSectionId] = (s.evaluators || [])
                .map((e: any) => e.tenderSectionEvaluatorId)
                .filter(Boolean);
            }
            return acc;
          }, {} as Record<string, number[]>),
          _originalDocumentIds: allDocs
            .map((d: any) => d.docId)
            .filter(Boolean),
          _instructionsDocId: instructionsDoc?.docId,
          _termsDocId: termsDoc?.docId,
        };

        formMethods.reset(formValues);
      } catch (error) {
        console.error("Failed to load draft tender:", error);
      } finally {
        setLoading(false);
      }
    };
    loadDraft();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftId]);

  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);
  return (
    <>
      <Head title="User List - Profile" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">{draftId ? "Edit Tender" : "New Tender"}</BlockTitle>
                  </BlockHeadContent>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Block className="mt-1">
                {loading == true ? (
                  <>
                    <Flex align="center" gap="middle" className="pageLoader">
                      <Spin size="large" className="m-auto" />
                    </Flex>
                  </>
                ) : (
                  <div className="nk-wizard nk-wizard-simple is-alter wizard clearfix">
                    <FormProvider {...formMethods}>
                      <Steps config={config}>
                        <Step component={GeneralDetails} />
                        <Step component={Materails} />
                        <Step component={Questioner} />
                        <Step component={Others} />
                        <Step component={Preview} />
                      </Steps>
                    </FormProvider>
                  </div>
                )}
              </Block>
            </div>
          </div>
        </Card>
      </Content>
    </>
  );
};

export default NewTenderMain;
